import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=e595d32c&scoped=true&"
import script from "./PageLayout.vue?vue&type=script&lang=js&"
export * from "./PageLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=e595d32c&lang=less&scoped=true&"
import style1 from "./PageLayout.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e595d32c",
  null
  
)

export default component.exports